<template>
  <div class="join">
    <el-dialog width="500px" title="重新绑定" :visible.sync="showBind">
       <el-form ref="form" label-width="120px">
         <el-form-item label="运维人员姓名">
           <el-autocomplete
             class="drug-input"
             v-model="saleName"
             :fetch-suggestions="querySearch"
             placeholder="请输入运维人员"
             :trigger-on-focus="false"
             @select="handleSelect"
             @focus="setIndex(index)"
           ></el-autocomplete>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" @click="reBind">确定</el-button>
           <el-button @click="cancle">取消</el-button>
         </el-form-item>
       </el-form>
    </el-dialog>
    <el-dialog width="570px" class="timeSetting" title="定时设置" v-if="showTime" :visible.sync="showTime" :before-close="handleClose">
       <time-setting :deviceInfo="deviceInfo"></time-setting>
    </el-dialog>
    <div class="title"><img src="../assets/circle.png">
       <b>绑定设备</b>
       <el-select class="selectSate" v-model="state" placeholder="请选择">
           <el-option
             v-for="item in options"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
        </el-select>
        <el-button type="primary" size="medium" class="reback" @click="reback">返回</el-button>
       <!-- <el-button type="primary" size="medium" class="reBind" @click="reBindDevice">重新绑定</el-button> -->
    </div>
    <div class="searchDiv">
      <div class="searchDivLeft">
        <el-input v-model="keyword" placeholder="请输入设备ID查询"></el-input><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
    </div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="4%"><input type="checkbox" v-model="checked" @change="checkAll"></th><th width="8%">设备ID</th><th width="15%">设备名称</th><!-- <th width="20%">设备地址</th> --><th width="10%">设备型号</th><th width="10%">单路/双路</th><th width="10%">状态</th><th width="10%">定时设置</th></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center"><input v-model="selectDevice" type="checkbox" :value="item.id"></td>
          <td align="center">{{item.deviceId}}</span></td>
          <td align="center">{{item.deviceName}}</span></td>
<!--          <td align="center">{{item.address}}</span></td> -->
          <td align="center">{{item.deviceType}}</span></td>
          <td align="center"><span>{{item.road|changeRoad}}</span></td>
          <td align="center">{{item.state|changeState}}</span></td>
          <td align="center"><span class="view" @click="viewTime(item.deviceId)">查看</span></td>
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :total='total' :currentPage='cur' :pageSize='pageSize' @pageNum="getPage"></page></div>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import Pinyin from 'pinyin-match'
import {getDeviceList,changeOperator,getOperatorList,getDeviceDetail} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditType from '@/components/EditType'
import TimeSetting from '@/components/TimeSetting'
import Loading from '@/components/Loading'
export default {
  name: 'device',
  data () {
    return {
      joinList:[],
      deviceIds:[],
      memberInfo:{},
      keyword:'',
      showNodata:false,
      showTime:false,
      showBind:false,
      showLoading:false,
      timeList:[],
      checked:false,
      selectDevice:[],  //需要重新绑定的设备
      selectOperator:'', //旧运维人员ID
      saleId:'',         //新运维人员ID
      saleName:'',       //新运维人员姓名
      state:'A',
      options: [{
              value: 'A',
              label: '全部'
            },
            {
              value: 'Y',
              label: '在线'
            },{
              value: 'N',
              label: '离线'
            }],
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 ,//总条数
      id:'',
      opratorList:[],
      saleNames:[],
      index:'',
    }
  },
  mounted(){
    var id=this.$route.query.id
    this.id=id
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    search(){
      this.cur=1
      this.getData()
    },
    cancle(){
      this.showBind=false
      this.saleId=''
    },
    querySearch(queryString, cb) {
          var drugNames = this.saleNames;
          var results = queryString ? drugNames.filter(this.createFilter(queryString)) : restaurants;
          // 调用 callback 返回搜索的会员
          cb(results);
    },
    createFilter(queryString) {
          return (restaurant) => {
            return (Pinyin.match(restaurant.value.toLowerCase(), queryString.toLowerCase())) ;
          };
    },
    handleSelect(item){
      console.log(item)
      this.saleName=item.value
      this.saleId=item.id
    },
    setIndex(index){
      this.index=index
    },
    reBindDevice(){
      let send=true
      if(this.selectDevice.length>0){
        var selectOperator=''
        this.joinList.forEach((item,index)=>{
          this.selectDevice.forEach((item1,index1)=>{
            if(item.id==item1){
              if(selectOperator==''){
                selectOperator=item.devopsIds
              }
              if(selectOperator!=item.devopsIds){
                 this.$message({
                    message: '只能选择同一维护人员下设备',
                    type: 'warning'
                 })
                 send=false
              }else{
                this.selectOperator=selectOperator
              }
            }
          })
        })
        if(send){
          this.showBind=true
        }
      }else{
        this.$message({
           message: '请选择设备',
           type: 'warning'
        })
      }

    },
    reBind(){
       if(this.saleId!=''){
          let data=JSON.stringify({
            "devOpsId":this.saleId,
            "oldDevOpsId":this.id,
            "deviceIds":this.selectDevice
          })
          changeOperator(data).then(res=>{
            if(res.data.state==200){
              this.saleName=''
              this.showBind=false
              this.getData()
              this.$message({
                 message: '操作成功',
                 type: 'success'
              })
            }else{
              this.$message({
                 message: '操作失败',
                 type: 'warning'
              })
            }
          })
       }else{
         this.$message({
            message: '请选择新运维',
            type: 'warning'
         })
       }
    },
    checkAll(){
      if(!this.checked){
        this.selectDevice=[]
      }else{
        this.selectDevice=this.deviceIds
      }
    },
    reback(){
      this.$router.back()
    },
    handleClose(done) {
      done();
      this.tabIndex=0
      this.dayList=[]
      this.timeList=[]
    },
    viewTime(id){
      var data=JSON.stringify({
          "deviceNumber": id,
      })
      getDeviceDetail(data).then(res=>{
        if(res.data.state==200){
          this.deviceInfo=res.data.data
          this.showTime=true
        }else{

        }
      })
    },
    getData(){
      var data=JSON.stringify({
          "deviceId": "",
          "deviceNumber":this.keyword,
          "devOpsId":"",
          "usrId": this.id,
          "deviceState": this.state,
          "pageSize": this.pageSize,
          "currentPage": this.cur
      })
      this.showLoading=true
      getDeviceList(data).then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
          var records=[]
          this.joinList.forEach((item,index)=>{
            records.push(item.id)
          })
          this.deviceIds=records
          var data=JSON.stringify({})
          getOperatorList(data).then(res=>{
            if(res.data.state==200){
              const {data}=res.data
              data.forEach((item,index)=>{
                this.joinList.forEach((item1,index1)=>{
                  if(item1.devopsIds==item.id){
                    item1.trueNme=item.trueName
                  }
                })
              })
              this.$forceUpdate()
              this.saleNames=data.map(item=>{
                let trueName=item.trueName+'/'+item.phone
                return {value:trueName,id:item.id}
              })
            }
          })
        }
      }).catch(err=>{
        this.showLoading=false
      })
    },
    getPage(data){
      this.cur=data
    }
  },
  filters:{
    changeRoad(val){
      if(val==1){
        return '单路'
      }
      if(val==2){
        return '双路'
      }
    },
    changeOperatorName(val){
      this.opratorList.forEach((item,index)=>{
        if(item.id==val){
          return item.trueName
        }
      })
      console.log(val)
    },
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val){
        return val.slice(0,len)
      }
    },
    cutserial(val){
       var len=val.toString().length
       console.log(len)
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    },
    changeState(val){
      return val=='Y'?'在线':'离线'
    },
    changeTime(val){
      return parseFloat(val)/60
    }
  },
  watch:{
    cur(val){
      this.getData('')
    },
    state(val){
      this.cur=1
      this.keyword=''
      this.getData()
    },
    selectDevice() {
    			if (this.selectDevice.length == this.deviceIds.length) {
    				this.checked = true
    			} else {
    				this.checked = false
    			}
    		}
  },
  components:{
    Page,
    EditType,
    TimeSetting,
    Loading
  },
  // beforeRouteEnter(to,from,next) {
  //   var that=this
  //   var manager=localStorage.getItem('manager')
  //   if(manager=='M'){
  //     next()
  //   }else{
  //      alert('您没有访问权限')
  //      next('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;margin-top:20px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:400px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#fff;font-size:12px;padding:7px 10px;border-radius:4px;margin-left:5px;margin-right:5px;background:#409eff;cursor: pointer;}
   .addBn {float: right;}
   .view {color:#357af1;cursor: pointer;}
   .timeTable {width:100%;position: relative;top:-10px;border-collapse: collapse;}
   .timeTable th {height:35px;line-height:35px;background:#f4f4f4;}
   .timeTable td {height:30px;line-height:30px;text-align:center;border:#f4f4f4 1px solid;}
   .selectSate {width:100px;margin-left:20px}
   .reBind {float: right;}
   .reback {margin-left:15px;float: right;}
</style>



// WEBPACK FOOTER //
// src/views/CustomerDevice.vue